import {
  AccountStatus,
  IUser,
  IUserProfile,
} from "@centraldispatch/singlespa-utilities";
import { Profile } from "oidc-client";
import { IAuthenticator } from "./authenticator";

export enum Tier {
  BROKER = "BROKER",
  CARRIER = "CARRIER",
  DEALER = "DEALER",
}

export class UserProfile implements IUserProfile {
  customerId: string;
  username: string;
  companyName: string;
  tierGroup: Tier;
  accessToken: string;
  userId: string;
  activationDate: Date;
  marketplaceIds: number[];
  numberOfAccounts: number;
  accountStatus: AccountStatus;
  roles: string[];

  constructor();
  constructor(userProfile: Profile, accessToken: string);

  constructor(userProfile?: Profile, accessToken?: string) {
    this.customerId = userProfile.customerId;
    this.username = userProfile.sub;
    this.companyName = userProfile.companyName;
    this.tierGroup = Tier[userProfile.tierGroup?.toUpperCase()];
    this.accessToken = accessToken;
    this.userId = userProfile.userId;
    this.activationDate = userProfile.activationDate;
    this.marketplaceIds = Array.isArray(userProfile.marketPlaceIds)
      ? userProfile.marketPlaceIds
      : [userProfile.marketPlaceIds];
    this.numberOfAccounts = userProfile.numberOfAccounts;
    this.roles = Array.isArray(userProfile.roles)
      ? userProfile.roles
      : [userProfile.roles];
    this.accountStatus = userProfile.accountStatus;
  }
}

export class User implements IUser {
  private readonly _authenticator: IAuthenticator;

  constructor(authenticator: IAuthenticator) {
    this._authenticator = authenticator;
  }

  getProfileAsync = async (): Promise<IUserProfile> => {
    const user = await this._authenticator.getUserManager().getUser();

    if (user) {
      const userProfile = new UserProfile(user.profile, user.access_token);

      console.info(userProfile);

      return userProfile;
    }

    return null;
  };
}
